module.exports = __webpack_public_path__ + "media/images/icon-edu-card-carbon-bc8c2dc5071bd6599e9d6c483b5a736e.svg";